import { addIndex, map, merge, range, adjust, always } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import { validations } from 'common';
import QuickSelect from './QuickSelect.jsx';
import { q1Questions } from './QuestionnairesData';

const colors = ['', 'blue', 'blue', 'green', 'green'];
const descriptions = [ '', 'Nunca/casi nunca', 'Pocas veces', 'Frecuentemente', 'Siempre/casi siempre'];

export default class Questionnaire1 extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {};
    this.editable = this.props.editable !== false;
    this.enableLeaveMessage();
  }
  componentDidUpdate() {
    this.enableLeaveMessage();
  }
  componentWillUnmount() {
    window.onbeforeunload = null;
  }
  enableLeaveMessage() {
    if (this.props.canSave) {
      window.onbeforeunload = (event) => (event || window.event).returnValue = 'Tienes cambios sin guardar.'
    } else {
      window.onbeforeunload = null;
    }
  }
  render() {
    const complete = validations.finishedQuestionnaire1(this.props.value);
    const incompleteError = () => alert('Faltan campos de llenar.');
    let continueClasses = 'btn btn-lg btn-success';
    if (!complete) {
      continueClasses += ' disabled';
    }

    return (
      <form>
        <h1>Cuestionario 1</h1>
        <If condition={this.editable}>
          <div>
           <table className='pull-right'>
              <thead>
                <tr>
                  <th></th>
                  <th style={{ width: '40px' }}><b>Escala</b></th>
                </tr>
              </thead>
              <tbody>
                <tr><td style={{ color: '#1AAF54' }}>Sí me describe, siempre o casi siempre.</td><td style={{ textAlign: 'center', border: '1px solid black', background: '#1AAF54' }}><b>4</b></td></tr>
                <tr><td style={{ color: '#1AAF54' }}>Sí me describe, la mayoría de las veces.</td><td style={{ textAlign: 'center', border: '1px solid black', background: '#1AAF54' }}><b>3</b></td></tr>
                <tr><td style={{ color: '#BE0712' }}>No me describe, la mayoría de las veces.</td><td style={{ textAlign: 'center', border: '1px solid black', background: '#BE0712' }}><b>2</b></td></tr>
                <tr><td style={{ color: '#BE0712' }}>No me describe, nunca o casi nunca.</td><td style={{ textAlign: 'center', border: '1px solid black', background: '#BE0712' }}><b>1</b></td></tr>
              </tbody>
            </table>
            <br />
            <h5>Responde a cada una de las 40 frases descriptiva usando la siguiente escala:</h5>
            <h5>Se honesto contigo mismo para que el resultado sea de utilidad para ti y para el ejercicio.</h5>
            <br />
            <br />
          </div>
        </If>
        {addIndex(map)(this.renderQuestion, q1Questions)}
        <If condition={this.editable}>
          <div style={{ textAlign: 'right' }}>
            <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className='btn btn-lg btn-info' disabled={!this.props.canSave} onClick={this.props.onSave}>{ this.props.canSave ? 'Guardar' : 'Guardado' }</button>
            <button type='button' style={{ display: 'inline-block', margin: '0px 10px' }} className={continueClasses} onClick={complete ? this.props.onSubmit : incompleteError}>Continuar</button>
          </div>
        </If>
      </form>
    );
  }
  renderQuestion(question, index) {
    const rowStyle = merge({ borderRadius: '5px', padding: '15px 0px', margin: '25px 0px', verticalAlign: 'middle', backgroundColor: index%2 ? '#EEEEEE' : '#DFDFDF' }, this.props.smallScreen ? { marginBottom: '30px' } : {});
    return (
      <div className='row' style={rowStyle} key={'1' + index} >
        <div className='col-lg-8 col-xs-12' style={{ paddingTop: '10px' }}>
          <b>{index + 1}.</b> {question}
        </div>
        <div className='col-lg-2' style={{ paddingTop: '10px' }}>
          <b style={{ color: colors[this.props.value[index]] }}>{descriptions[this.props.value[index]]}</b>
        </div>
        <div className='col-lg-2 col-xs-12' style={{ textAlign: this.props.smallScreen ? 'left' : 'right' }}>
          <QuickSelect editable={this.editable} values={range(1, 5)} value={this.props.value[index]} onChange={this.handleOptionClick(index)} />
        </div>
      </div>
    );
  }
  handleOptionClick(index) {
    return (value) => {
      this.props.onChange(adjust(always(value), index, this.props.value))
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/questionnaires/Questionnaire1.jsx